import React, { useEffect } from 'react';
import DemosList from './DemosList';
import CreateDemo from './CreateDemo';
import { Demo } from '../types/Demo';
import { apiService } from '../services/api';

interface MainContentProps {
  activeTab: 'demos' | 'create';
  demos: Demo[];
  setDemos: (demos: Demo[]) => void;
  refreshTrigger: number;
}

const MainContent: React.FC<MainContentProps> = ({
  activeTab,
  demos,
  setDemos,
  refreshTrigger,
}) => {
  useEffect(() => {
    loadDemos();
  }, [refreshTrigger]);

  const loadDemos = async () => {
    try {
      const response = await apiService.getDemos();
      setDemos(response.demos);
    } catch (error) {
      console.error('Error loading demos:', error);
    }
  };

  return (
    <div className="main-content">
      {activeTab === 'demos' ? (
        <DemosList demos={demos} onDemoDeleted={loadDemos} />
      ) : (
        <CreateDemo onDemoCreated={loadDemos} />
      )}
    </div>
  );
};

export default MainContent;